import React, { useMemo } from "react";
import { FaMedal } from "react-icons/fa";

const genderLabel = (g) => {
  const GG = String(g || "").toUpperCase();
  if (GG === "F") return "Féminin";
  if (GG === "M") return "Masculin";
  return "—";
};

const isPodiumRank = (label) => ["1", "2", "3"].includes(String(label));

// ✅ détecte "non_classes", "non_classe", "non classé", etc.
const isNcFormula = (f = "") =>
  /non[\s_-]*class/i.test(String(f || ""));

const PublicPodiums = ({ data = [] }) => {
  // ✅ Filtre : pas de NC + pas de distributions vides
  const visible = useMemo(() => {
    return (data || []).filter(({ distribution: dist, entries }) => {
      if (!dist) return false;
      if (isNcFormula(dist.formule_repartition)) return false;
      if (!Array.isArray(entries) || entries.length === 0) return false;
      return true;
    });
  }, [data]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {visible.map(({ distribution: dist, entries }) => {
        const tapis = dist?.numero_tapis ?? "—";
        const age = dist?.categorie_age || "—";
        const poids = dist?.categorie_poids || "—";
        const genre = genderLabel(dist?.genre);

        const formule = String(dist?.formule_repartition || "")
          .replaceAll("_", " ")
          .trim();

        return (
          <div
            key={dist?.id}
            className="bg-white dark:bg-slate-900 shadow-lg rounded-2xl overflow-hidden border border-gray-200/70 dark:border-slate-700/70 flex flex-col"
          >
            {/* Header */}
            <div className="bg-blue-700 text-white px-4 py-2 text-sm font-bold tracking-wider uppercase">
              #{dist?.id} — Tapis {tapis} — {age} — {genre}
            </div>

            {/* Infos */}
            <div className="px-4 py-3 text-sm text-gray-800 dark:text-gray-300 bg-gray-50 dark:bg-slate-800/50">
              <div>
                <span className="font-semibold">Poids :</span> {poids}
              </div>
              <div className="text-xs mt-1">
                <span className="font-semibold">Formule :</span> {formule || "—"}
              </div>
            </div>

            {/* Liste */}
            <ul className="divide-y divide-gray-200 dark:divide-slate-700 px-4 py-3">
              {entries.map((c) => (
                <li
                  key={c.id}
                  className="py-2 flex items-center justify-between gap-3"
                >
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                      {c.nom_competiteur} {c.prenom_competiteur}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                      {c.club_competiteur}
                    </p>
                  </div>

                  <div className="text-right flex items-center gap-2">
                    {isPodiumRank(c._rankLabel) && (
                      <span className="text-xs text-yellow-700 dark:text-yellow-300 inline-flex items-center gap-1">
                        <FaMedal /> Podium
                      </span>
                    )}
                    <span className="text-lg font-extrabold min-w-[28px] text-right">
                      {c._rankLabel ?? "—"}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        );
      })}

      {visible.length === 0 && (
        <div className="col-span-full text-center text-gray-500 dark:text-gray-400">
          Aucun podium disponible.
        </div>
      )}
    </div>
  );
};

export default PublicPodiums;
